import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  TablePagination,
  Chip,
  IconButton,
  Box,Card, CardContent, Typography
} from "@mui/material";
import FilterHeader from "../../Components/FilterHeader/FilterHeader";
import EditIcon from "@mui/icons-material/Edit";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { AddBoxTwoTone } from "@mui/icons-material";
const HolidayTable = ({
  holidayList,
  loading,
  pagination,
  onPageChange,
  searchTerm,
  setSearchTerm,
  dateRange,
  setDateRange,
  onEdit,
  onAssing,
}) => {
  return (
    <>
      <FilterHeader
        total={pagination.total}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        dateRange={dateRange}
        setDateRange={setDateRange}
        showDatePicker={true}
      />

      <Paper
        sx={{ mt: 2, width: "100%", display: { xs: "none", md: "block" } }}
        elevation={3}
      >
        <TableContainer width="100%">
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#000" }}>
                <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                  S.No.
                </TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                  Date
                </TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                  Title
                </TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                  Type
                </TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                  Status
                </TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                  Action
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    <CircularProgress size={24} />
                  </TableCell>
                </TableRow>
              ) : holidayList.length > 0 ? (
                holidayList.map((row, index) => (
                  <TableRow key={row.id}>
                    <TableCell>
                      {(pagination.page - 1) * pagination.limit + index + 1}
                    </TableCell>
                    <TableCell>
                      {new Date(row.holiday_date).toLocaleDateString()}
                    </TableCell>
                    <TableCell>{row.title}</TableCell>
                    <TableCell>
                      <Chip
                        label={row.holiday_type}
                        color={
                          row.holiday_type === "global" ? "primary" : "warning"
                        }
                        size="small"
                      />
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={row.active ? "Active" : "Inactive"}
                        color={row.active ? "success" : "error"}
                        size="small"
                      />
                    </TableCell>
                    <TableCell
                      sx={{ display: "flex", alignItems: "center", gap: 1 }}
                    >
                      <IconButton
                        size="small"
                        color="primary"
                        onClick={() => onEdit(row)}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                      {row.holiday_type === "batch" && (
                        <IconButton
                          size="small"
                          color="primary"
                          onClick={() => onAssing(row)}
                        >
                          <AddBoxTwoTone fontSize="small" />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No data found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <TablePagination
          component="div"
          count={pagination.total}
          page={pagination.page - 1}
          onPageChange={(e, newPage) =>
            onPageChange(newPage + 1, pagination.limit)
          }
          rowsPerPage={pagination.limit}
          onRowsPerPageChange={(e) =>
            onPageChange(1, parseInt(e.target.value, 10))
          }
          rowsPerPageOptions={[5, 10, 25]}
        />
      </Paper>
      <Box sx={{ display: { xs: "block", md: "none" } }}>
        {loading ? (
          <Box sx={{ textAlign: "center", mt: 2 }}>
            <CircularProgress size={24} />
          </Box>
        ) : holidayList.length > 0 ? (
          holidayList.map((row) => (
            <Card key={row.id} sx={{ mb: 2, borderRadius: 2, boxShadow: 2 }}>
              <CardContent>
                <Typography fontWeight="bold">
                  {new Date(row.holiday_date).toLocaleDateString()}
                </Typography>

                <Typography sx={{ mt: 0.5 }}>{row.title}</Typography>

                <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
                  <Chip
                    label={row.holiday_type}
                    size="small"
                    color={
                      row.holiday_type === "global" ? "primary" : "warning"
                    }
                  />
                  <Chip
                    label={row.active ? "Active" : "Inactive"}
                    size="small"
                    color={row.active ? "success" : "error"}
                  />
                </Box>

                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}
                >
                  <IconButton
                    size="small"
                    color="primary"
                    onClick={() => onEdit(row)}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>

                  {row.holiday_type === "batch" && (
                    <IconButton
                      size="small"
                      color="primary"
                      onClick={() => onAssing(row)}
                    >
                      <AddBoxTwoTone fontSize="small" />
                    </IconButton>
                  )}
                </Box>
              </CardContent>
            </Card>
          ))
        ) : (
          <Typography align="center">No data found</Typography>
        )}
      </Box>
       {/* Pagination */}
        <TablePagination
          component="div"
          count={pagination.total}
          page={pagination.page - 1}
          onPageChange={(e, newPage) =>
            onPageChange(newPage + 1, pagination.limit)
          }
          rowsPerPage={pagination.limit}
          onRowsPerPageChange={(e) =>
            onPageChange(1, parseInt(e.target.value, 10))
          }
          rowsPerPageOptions={[5, 10, 25]}
        />
    </>
  );
};

export default HolidayTable;
